import { SidebarOpenMode, IDetailsPayload } from '../detailsSidebar.interface';

const getMode = (value: unknown): SidebarOpenMode => {
  switch (value) {
    case SidebarOpenMode.Create:
    case SidebarOpenMode.Copy:
    case SidebarOpenMode.View:
    case SidebarOpenMode.Edit:
      return value as SidebarOpenMode;
    default:
      return undefined;
  }
};

export const getDetailsFromLocationState = (state: unknown): {
  mode?: SidebarOpenMode;
  type?: IDetailsPayload['type'];
  sourceId?: IDetailsPayload['id'];
} => {
  if (!state || !(state instanceof Object)) {
    return { mode: undefined, type: undefined };
  }

  return {
    mode: getMode(state['mode']),
    type: state['type'],
    sourceId: state['sourceId'],
  };
};
